import {
  SMART_DROPDOWN_FILE_UPLOAD,
  SMART_DROPDOWN_FILE_UPLOAD_SUCCESS,
  SMART_DROPDOWN_FILE_UPLOAD_ERROR,
  SMART_DROPDOWN_NOTIFICATION_UPLOAD_FILES,
} from "./actionTypes"

export const fileUpload = data => ({
  type: SMART_DROPDOWN_FILE_UPLOAD,
  payload: data
});

export const fileUploadSuccess = data => ({
  type: SMART_DROPDOWN_FILE_UPLOAD_SUCCESS,
  payload: {data}
});

export const fileUploadError = error => ({
  type: SMART_DROPDOWN_FILE_UPLOAD_ERROR,
  payload: error,
});

export const notificationUploadFiles = data => ({
  type: SMART_DROPDOWN_NOTIFICATION_UPLOAD_FILES,
  payload: data
});
